import { MenuConfig } from 'commonTypes'
import compoundsIcon from 'assets/icons/menu/compounds-icon.svg'
import sampleIcon from 'assets/icons/menu/sample-icon.svg'

const menuConfig: Array<MenuConfig> = [
    {
        id: 'compounds',
        show: true,
        name: 'Compounds',
        iconSrc: compoundsIcon,
        route: '/compounds',
        subMenu: [],
        scrollTo: ''
    },
    {
        id: 'targets',
        show: true,
        name: 'Targets',
        iconSrc: sampleIcon,
        route: '/targets',
        subMenu: [],
        scrollTo: ''
    },
    {
        id: 'alterations',
        show: true,
        name: 'Alterations detected',
        iconSrc: sampleIcon,
        route: '/drivers',
        subMenu: [],
        scrollTo: ''
    }
]

export default menuConfig
